module.exports = __webpack_public_path__ + "static/2-e3f43de241401c1b93bdf5847a3cecac.jpg";